import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=1a81a11a&scoped=true&lang=pug&"
import script from "./LockScreen.vue?vue&type=script&lang=js&"
export * from "./LockScreen.vue?vue&type=script&lang=js&"
import style0 from "./LockScreen.vue?vue&type=style&index=0&id=1a81a11a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a81a11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
